import { render, staticRenderFns } from "./SortingIcons.vue?vue&type=template&id=137df810"
import script from "./SortingIcons.vue?vue&type=script&lang=js"
export * from "./SortingIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports